// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fullWidthContainer {
  width: 100%; 
  height: calc(100vh - 100px); 
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 90%;
  height: 90%;
  background-color: white;
  margin-top: -100px;
  overflow: hidden;
  padding: 20px;
}

.h5Text {
  width: 100%;
  text-align: left; 
  font-family: 'Arial', sans-serif; 
  font-size: 24px; 
  margin-bottom: 20px; 
  color: black; 
}

.scroll-btn {
  width: 30px;
  height: 60%;
  background-color: green;
  color: white;
  border: none;
  cursor: pointer;
  margin: 0 10px;
  position: absolute;
  top: 50%; 
  transform: translateY(-50%);
  
}

.scroll-btn.disabled {
  background-color: rgba(128, 128, 128, 0.3);
  cursor: not-allowed;
}

.scroll-btn.left {
  left: 0; 
}

.scroll-btn.right {
  right: 0; 
}

iframe {
  width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden;
}

.pagination-stack {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -70px;
}

.pagination-stack .MuiPagination-root {
  border-radius: 20px;
}

.pagination-stack .MuiPaginationItem-root {
  color: green; 
  border-radius: 20px; 
  padding: 8px;
  border: 1px solid green;
}

.pagination-stack .MuiPaginationItem-page.Mui-selected {
  background-color: #E2FBBD; 
  color: green;
}

.logos-container-supervision {
  display: flex;
  justify-content: center;
  padding: 10px;
  overflow: hidden;
  align-items: center;
  margin: -10px 10px;
}

.logo-panel {
  width: 20%;
  height: auto;
  margin: -50px -70px;
}

/* Estilos generales */
.fullWidthContainer {
  width: 100%; 
  height: calc(100vh - 100px); 
  display: flex;
  justify-content: center;
  align-items: center;
}

.box {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 90%;
  height: 90%;
  background-color: white;
  margin-top: -100px;
  overflow: hidden;
  padding: 20px;
}

.h5Text {
  width: 100%;
  text-align: left; 
  font-family: 'Arial', sans-serif; 
  font-size: 24px; 
  margin-bottom: 20px; 
  color: black; 
}

.scroll-btn {
  width: 30px;
  height: 60%;
  background-color: green;
  color: white;
  border: none;
  cursor: pointer;
  margin: 0 10px;
  position: absolute;
  top: 50%; 
  transform: translateY(-50%);
}

.scroll-btn.disabled {
  background-color: rgba(128, 128, 128, 0.3);
  cursor: not-allowed;
}

.scroll-btn.left {
  left: 0; 
}

.scroll-btn.right {
  right: 0; 
}

iframe {
  width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden;
}

.pagination-stack {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -70px;
}

.pagination-stack .MuiPagination-root {
  border-radius: 20px;
}

.pagination-stack .MuiPaginationItem-root {
  color: green; 
  border-radius: 20px; 
  padding: 8px;
  border: 1px solid green;
}

.pagination-stack .MuiPaginationItem-page.Mui-selected {
  background-color: #E2FBBD; 
  color: green;
}

.logos-container-supervision {
  display: flex;
  justify-content: center;
  padding: 10px;
  overflow: hidden;
  align-items: center;
  margin: -10px 10px;
}

.logo-panel {
  width: 20%;
  height: auto;
  margin: -50px -70px;
}

@media (max-width: 430px) {
  .box {
    width: 75%;
    height: 80%;
    padding: 15px;
  }

  .h5Text {
    font-size: 18px;
  }

  .scroll-btn {
    width: 20px;
  }
  
  .logo-panel {
    width: 30%;
    margin: -10px -90px;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .box {
    width: 85%;
    height: 80%;
    padding: 20px;
  }

  .h5Text {
    font-size: 22px;
  }

  .scroll-btn {
    width: 25px;
  }

  .logo-panel {
    width: 25%;
    margin: -20px -40px;
  }
}

@media (min-width: 1280px) and (max-width: 1440px) {
  .box {
    width: 85%;
  }

  .h5Text {
    font-size: 24px;
  }

  .scroll-btn {
    width: 35px;
  }

  .logo-panel {
    width: 20%;
  }
}

@media (min-width: 2560px) {
  .box {
    width: 80%;
  }

  .h5Text {
    font-size: 28px;
  }

  .scroll-btn {
    width: 40px;
  }

  .logo-panel {
    width: 10%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/PaneldeSupervision.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;;AAE7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,WAAW;IACX,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".fullWidthContainer {\n  width: 100%; \n  height: calc(100vh - 100px); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 90%;\n  height: 90%;\n  background-color: white;\n  margin-top: -100px;\n  overflow: hidden;\n  padding: 20px;\n}\n\n.h5Text {\n  width: 100%;\n  text-align: left; \n  font-family: 'Arial', sans-serif; \n  font-size: 24px; \n  margin-bottom: 20px; \n  color: black; \n}\n\n.scroll-btn {\n  width: 30px;\n  height: 60%;\n  background-color: green;\n  color: white;\n  border: none;\n  cursor: pointer;\n  margin: 0 10px;\n  position: absolute;\n  top: 50%; \n  transform: translateY(-50%);\n  \n}\n\n.scroll-btn.disabled {\n  background-color: rgba(128, 128, 128, 0.3);\n  cursor: not-allowed;\n}\n\n.scroll-btn.left {\n  left: 0; \n}\n\n.scroll-btn.right {\n  right: 0; \n}\n\niframe {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  overflow: hidden;\n}\n\n.pagination-stack {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -70px;\n}\n\n.pagination-stack .MuiPagination-root {\n  border-radius: 20px;\n}\n\n.pagination-stack .MuiPaginationItem-root {\n  color: green; \n  border-radius: 20px; \n  padding: 8px;\n  border: 1px solid green;\n}\n\n.pagination-stack .MuiPaginationItem-page.Mui-selected {\n  background-color: #E2FBBD; \n  color: green;\n}\n\n.logos-container-supervision {\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n  overflow: hidden;\n  align-items: center;\n  margin: -10px 10px;\n}\n\n.logo-panel {\n  width: 20%;\n  height: auto;\n  margin: -50px -70px;\n}\n\n/* Estilos generales */\n.fullWidthContainer {\n  width: 100%; \n  height: calc(100vh - 100px); \n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 90%;\n  height: 90%;\n  background-color: white;\n  margin-top: -100px;\n  overflow: hidden;\n  padding: 20px;\n}\n\n.h5Text {\n  width: 100%;\n  text-align: left; \n  font-family: 'Arial', sans-serif; \n  font-size: 24px; \n  margin-bottom: 20px; \n  color: black; \n}\n\n.scroll-btn {\n  width: 30px;\n  height: 60%;\n  background-color: green;\n  color: white;\n  border: none;\n  cursor: pointer;\n  margin: 0 10px;\n  position: absolute;\n  top: 50%; \n  transform: translateY(-50%);\n}\n\n.scroll-btn.disabled {\n  background-color: rgba(128, 128, 128, 0.3);\n  cursor: not-allowed;\n}\n\n.scroll-btn.left {\n  left: 0; \n}\n\n.scroll-btn.right {\n  right: 0; \n}\n\niframe {\n  width: 100%;\n  height: 100%;\n  border: 0;\n  overflow: hidden;\n}\n\n.pagination-stack {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: -70px;\n}\n\n.pagination-stack .MuiPagination-root {\n  border-radius: 20px;\n}\n\n.pagination-stack .MuiPaginationItem-root {\n  color: green; \n  border-radius: 20px; \n  padding: 8px;\n  border: 1px solid green;\n}\n\n.pagination-stack .MuiPaginationItem-page.Mui-selected {\n  background-color: #E2FBBD; \n  color: green;\n}\n\n.logos-container-supervision {\n  display: flex;\n  justify-content: center;\n  padding: 10px;\n  overflow: hidden;\n  align-items: center;\n  margin: -10px 10px;\n}\n\n.logo-panel {\n  width: 20%;\n  height: auto;\n  margin: -50px -70px;\n}\n\n@media (max-width: 430px) {\n  .box {\n    width: 75%;\n    height: 80%;\n    padding: 15px;\n  }\n\n  .h5Text {\n    font-size: 18px;\n  }\n\n  .scroll-btn {\n    width: 20px;\n  }\n  \n  .logo-panel {\n    width: 30%;\n    margin: -10px -90px;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .box {\n    width: 85%;\n    height: 80%;\n    padding: 20px;\n  }\n\n  .h5Text {\n    font-size: 22px;\n  }\n\n  .scroll-btn {\n    width: 25px;\n  }\n\n  .logo-panel {\n    width: 25%;\n    margin: -20px -40px;\n  }\n}\n\n@media (min-width: 1280px) and (max-width: 1440px) {\n  .box {\n    width: 85%;\n  }\n\n  .h5Text {\n    font-size: 24px;\n  }\n\n  .scroll-btn {\n    width: 35px;\n  }\n\n  .logo-panel {\n    width: 20%;\n  }\n}\n\n@media (min-width: 2560px) {\n  .box {\n    width: 80%;\n  }\n\n  .h5Text {\n    font-size: 28px;\n  }\n\n  .scroll-btn {\n    width: 40px;\n  }\n\n  .logo-panel {\n    width: 10%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
